import { getCurrencyFormat } from '../../presentation/helpers/helper-price'

export const currencyFormat = getCurrencyFormat('BRL', 'none')
export const currencyFormatWithDisplay = getCurrencyFormat('BRL', 'symbol')
